var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import { getter } from '@progress/kendo-react-common';
/**
 * Represents the KendoReact Grid's StatusBar component.
 */
export var StatusBar = function (props) {
    var _a = props.data, data = _a === void 0 ? [] : _a;
    return (React.createElement("div", { className: "k-selection-aggregates k-grid-selection-aggregates" }, data.map(function (item, index) { return (React.createElement("div", { key: index },
        React.createElement("span", { className: "k-selection-aggregates-item-text" },
            item.type,
            ": "),
        React.createElement("span", { className: "k-selection-aggregates-item-value" }, item.formattedValue))); })));
};
StatusBar.displayName = 'KendoReactGridStatusBar';
;
;
/**
 * @hidden
 */
export var leafColumns = function (columns) {
    var _a;
    var result = columns.slice();
    for (var i = 0; i < result.length; i++) {
        while (result[i] && ((_a = result[i].children) === null || _a === void 0 ? void 0 : _a.length)) {
            result.splice.apply(result, __spreadArray([i, 1], result[i].children, false));
        }
    }
    return result;
};
;
/**
 * Calculates the status data.
 *
 * @param args StatusDataArgs
 * @returns StatusItem[]
 */
export var getStatusData = function (args) {
    var dataItems = args.dataItems, target = args.target, selectedField = args.selectedField;
    var columns = leafColumns(target.columns);
    var getters = columns.map(function (c) { return c.field; }).filter(function (f) { return f && typeof f === 'string'; }).map(function (f) { return getter(f); });
    var getSelected = getter(selectedField);
    var grouped = { dates: [], numbers: [], booleans: [], others: [] };
    var add = function (value) {
        if (typeof value === 'number') {
            grouped.numbers.push(value);
        }
        else if (typeof value === 'boolean') {
            grouped.booleans.push(value);
        }
        else if (value instanceof Date) {
            grouped.dates.push(value);
        }
        else {
            grouped.others.push(value);
        }
    };
    dataItems.forEach(function (item) {
        var selected = getSelected(item);
        if (selected) {
            selected.forEach(function (colIndex) {
                add(getters[colIndex](item));
            });
        }
    });
    var datesAsNumbers = grouped.dates.map(function (d) { return d.getTime(); });
    var isTrueCount = grouped.booleans.filter(function (bool) { return bool; }).length;
    var isFalseCount = grouped.booleans.filter(function (bool) { return !bool; }).length;
    var sum = grouped.numbers.length ? grouped.numbers.reduce(function (acc, curr) { return acc += curr; }, 0) : undefined;
    var aggregates = {
        sum: sum,
        average: typeof sum === 'number' ? sum / grouped.numbers.length : undefined,
        min: grouped.numbers.length ? Math.min.apply(Math, grouped.numbers) : undefined,
        max: grouped.numbers.length ? Math.max.apply(Math, grouped.numbers) : undefined,
        count: grouped.numbers.length + grouped.booleans.length + grouped.dates.length + grouped.others.length,
        isTrue: isTrueCount > 0 ? isTrueCount : undefined,
        isFalse: isFalseCount > 0 ? isFalseCount : undefined,
        earliest: grouped.dates.length ? new Date(Math.min.apply(Math, datesAsNumbers)) : undefined,
        latest: grouped.dates.length ? new Date(Math.max.apply(Math, datesAsNumbers)) : undefined
    };
    var format = function (value, key) {
        if ((key === 'sum' || key === 'average') && typeof value === 'number') {
            return value.toFixed(2);
        }
        else if ((key === 'earliest' || key === 'latest') && value instanceof Date) {
            return value.toLocaleDateString();
        }
        else {
            return String(value);
        }
    };
    var result = [];
    Object.keys(aggregates).forEach(function (a) {
        var type = a;
        var value = aggregates[type];
        if (value !== undefined) {
            result.push({ type: type, value: value, formattedValue: format(value, type) });
        }
    });
    return result;
};
